import { all } from 'redux-saga/effects'
import user from './user/sagas'
import menu from './menu/sagas'
import settings from './settings/sagas'
import apps from './apps/sagas'
import plans from './plans/sagas'
import billingHistory from './billingHistory/sagas'
import ai from './ai/sagas'

export default function* rootSaga() {
  yield all([user(), menu(), settings(), apps(), plans(), billingHistory(), ai()])
}
